import React from "react";

interface BottomLeftCornerProps {
  className?: string;
}

const BottomLeftCorner: React.FC<BottomLeftCornerProps> = ({ className }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.5 1.5C0.5 1.23478 0.562464 0.937536 0.75 0.75C0.937536 0.562464 1.23478 0.5 1.5 0.5M8.5 0.5C8.76522 0.5 9.06246 0.562464 9.25 0.75C9.43754 0.937536 9.5 1.23478 9.5 1.5M9.5 8.5C9.5 8.76522 9.43754 9.06246 9.25 9.25C9.06246 9.43754 8.76522 9.5 8.5 9.5M0.5 6C0.5 6 0.5 6.05474 0.5 6.25C0.5 8.25 2 9.5 4 9.5M9.5 6.5V6M0.5 4V3.5M9.5 4V3.5M3.5 0.5H4M6 9.5H6.5M6 0.5H6.5"
        stroke="#64748B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BottomLeftCorner;
